export class User {
  uid: string;
  email: string;
}
